import React, { useEffect, useState } from "react";
import { FormControl, FormLabel, Select, Spinner } from "@chakra-ui/react";

const PartySelectById = ({
  label = "Select Party",
  selectedPartyId,
  onChange,
  role,
  size = "md",
  height = undefined,
}) => {
  const [parties, setParties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchParties = async () => {
      setLoading(true);
      try {
        const url = new URL("https://directory.poc.mrc.ai/api/parties");
        if (role) {
          url.searchParams.set("roleCode", role);
        }

        const res = await fetch(url.toString());
        const json = await res.json();

        if (Array.isArray(json)) {
          const sorted = [...json].sort((a, b) =>
            (a.name || "").localeCompare(b.name || "")
          );
          setParties(sorted);
        } else {
          setParties([]);
        }
      } catch (err) {
        console.error("Failed to fetch parties:", err);
        setParties([]);
      } finally {
        setLoading(false);
      }
    };

    fetchParties();
  }, [role]);

  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      {loading ? (
        <Spinner />
      ) : (
        <Select
          placeholder="Select party..."
          value={selectedPartyId || ""}
          onChange={(e) => {
            onChange(e.target.value || null); // Send just the ID
          }}
          size={size}
          height={height}>
          {parties.map((party) => (
            <option key={party._id} value={party._id}>
              {party.name}
            </option>
          ))}
        </Select>
      )}
    </FormControl>
  );
};

export default PartySelectById;
